import BaseApiService from "../base_api.service";
import { AllergenModel } from "./models/allergen.model";

export class AllergenService extends BaseApiService {
  /**
   *
   */
  constructor() {
    super("Allergens");
  }

  async getList(): Promise<AllergenModel[]> {
    return (await this.get<AllergenModel[]>(``)) ?? [];
  }
}
